import { Injectable } from '@angular/core';
import { RestUtilsService } from 'src/app/service/rest/utils/rest-utils.service';
import { DeviceRepositoryService } from '../device/device-repository.service';
import { Device, SearchDevice } from '../device/device.model';
import { PlantRepositoryService } from '../plant/plant-repository.service';
import { Plant, SearchPlant } from '../plant/plant.model';
import { SearchCatalog } from '../utils.model';

@Injectable()
export class SearchCatalogService {

  private _searchCatalog : SearchCatalog;

  constructor(private utilsRest : RestUtilsService,
    private plantRepository : PlantRepositoryService,
    private deviceRepository : DeviceRepositoryService) {

    this.buildCatalog();
  }

  get searchCatalog() : SearchCatalog {
    return this._searchCatalog;
  }

  set searchCatalog(catalog : SearchCatalog) {
    this._searchCatalog = catalog;
  }

  buildCatalog() {
    let catalog = new SearchCatalog([],[]);

    this.plantRepository.plants.forEach((plant : Plant) => {
      let searchPlant : SearchPlant = new SearchPlant(plant.name, plant.id);
      catalog.plants.push(searchPlant);
    });

    this.deviceRepository.userDevices.forEach((device : Device) => {
      let searchDevice : SearchDevice = new SearchDevice(device.id, device.serialNumber, device.name, device.tags);
      catalog.devices.push(searchDevice);
    });

    this.searchCatalog = catalog;
  }
}
